import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'urql';

import { GET_SAVED_SETS, type View } from '@revelio/data-access';

export type UserSavedFilterSet = {
  id: string;
  name: string;
  view: View;
  default: boolean;
  shared: boolean;
  filters: string;
};

export const useGetStoredSets = () => {
  const [options, setOptions] = useState<UserSavedFilterSet[]>([]);

  const [{ fetching: fetchingSavedSets, data: savedSetsData }, refetchQuery] =
    useQuery({
      query: GET_SAVED_SETS,
      context: useMemo(() => ({ priority: 'low' as const }), []),
    });

  const refresh = () => {
    refetchQuery({ requestPolicy: 'network-only' });
  };

  useEffect(() => {
    if (!fetchingSavedSets && savedSetsData) {
      const fetchedSavedSets = (savedSetsData.presets ??
        []) as UserSavedFilterSet[];
      setOptions(fetchedSavedSets.map((set) => ({ ...set, children: [] })));
    }
  }, [fetchingSavedSets, savedSetsData]);

  return { fetchingSavedSets, options, refresh };
};
